// src/ImageCard.js
import React from 'react';
import { useDrop } from 'react-dnd';
import './ImageCard.css';

const ImageCard = ({ id, src, name, onDropWord }) => {
  const [{ isOver }, drop] = useDrop({
    accept: 'word',
    drop: (item) => onDropWord(id, item),
    collect: (monitor) => ({
      isOver: monitor.isOver(),
    }),
  });

  return (
    <div ref={drop} className={`image-card ${isOver ? 'over' : ''}`}>
      <img src={src} alt={name} />
      <p>{name}</p>
    </div>
  );
};

export default ImageCard;
